{
  "R": [0, 61, 122, 183, 244, 255],
  "G": [0, 41, 81, 122, 163, 255],
  "B": [0, 25, 51, 76, 102, 255],
  "A": [0, 25, 51, 71, 102, 128],
  "I": [0, 51, 102, 153, 204, 255]
}
